var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVehicles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.000000, -214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4705187,6 C17.9935013,5.99981492 18.3931216,5.94456267 18.6498161,6.34359044 L18.6498161,6.34359044 L21.6715106,11.0465259 C21.8859078,11.3797306 22,11.7665748 22,12.1616549 L22,12.1616549 L22,16.7171186 C22,17.0626968 21.8613506,17.3941209 21.6145531,17.6384816 C21.3677556,17.8828423 21.0330264,18.0201226 20.684002,18.0201226 L20.684002,18.0201226 L19.9999337,18.0201572 C19.9890927,19.6677343 18.65013,21 17,21 C15.3431458,21 14,19.6568542 14,18 L13.999,18.0123049 L9.99998657,18.0090746 C9.99526807,19.6026234 8.74809745,20.9038337 7.17627279,20.9949073 L7,21 C5.34314575,21 4,19.6568542 4,18 L3.999,18.0013049 C2.9442302,18.0010602 2.08171152,17.18546 2.00547743,16.1513905 L2,16.0022445 L2,7 C2,6.44771525 2.44771525,6 3,6 L3,6 Z",
    className: "invert-light"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,16 C18.1029597,16.0038632 18.9961231,16.8938818 19,17.9929577 C18.9905034,19.0933691 18.1007007,19.9847301 16.9964664,20 L17,19.9859155 C15.8970403,19.9820523 15.0038769,19.0920337 15,17.9929577 C15.0170469,16.899391 15.9025691,16.0169868 17,16 Z M8.72365299,16.9757689 C9.09211567,17.6067662 9.09211567,18.3932338 8.72365299,19.0242311 C8.35519032,19.6552284 7.67758354,20.0291715 6.95873377,19.9982168 L6.95873377,19.9804548 C5.87910299,19.9785072 5.0038268,19.0863814 5,17.9840143 C5.02601914,16.8935665 5.89059194,16.0186221 6.95873377,16.0017832 C7.67758354,15.9708285 8.35519032,16.3447716 8.72365299,16.9757689 Z M16.8255714,7 C16.9776133,7 17.1190028,7.06933281 17.1999283,7.18364117 L20.4423529,12.2297083 C20.5916309,12.4620242 20.5243154,12.7713672 20.2919995,12.9206452 C20.2113697,12.972455 20.1175484,13 20.0217077,13 L13.5,13 C13.2238576,13 13,12.7761424 13,12.5 L13,7.5 C13,7.22385763 13.2238576,7 13.5,7 L16.8255714,7 Z",
    className: "invert-dark"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVehicles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-vehicles.b5cc098a12595557606ade46d4e52397.svg";